import React, { useCallback } from "react";
import PropTypes from "prop-types";

import "react-datepicker/dist/react-datepicker.css"; // Import the DatePicker CSS
import FormControlTemplate from "../ui/formControlTemplate/FormControlTemplate.js";

const Label = React.lazy(() => import("../ui/label/Label"));
const DatePicker = React.lazy(() =>
  import("../ui/inputs/datePicker/DatePicker")
);
const ValidationText = React.lazy(() =>
  import("../ui/validation/ValidationText.js")
);

const FormDatePickerFields = ({
  dataField,
  labelName,
  name,
  keyId,
  value,
  error,
  formSetting,
  overRideProps,
  isRequired,
  fieldSetting,
  onChange,
  onBlure,
  onActionChange,
  ...otherProps
}) => {
  const handleDateChange = useCallback(
    (date) => {
      if (onChange) {
        onChange(dataField, date);
      }
    },
    [onChange, dataField]
  );

  const handleOnBlur = () => {
    if (onBlure) {
      onBlure?.(dataField);
    }
  };

  const handleButtonClick = (action) => {
    if (onActionChange) {
      onActionChange(action,dataField);
    }
  };

  return (
    <span className="date-validate">
      <div className="date-picker-label-part">
        <div className="input-label-part">
          {labelName && <Label labelName={labelName} isRequired={isRequired} />}
        </div>
        {fieldSetting?.subTitle && (
          <div className="section-title">
            <h5>{fieldSetting.subTitle}</h5>
          </div>
        )}
        <div
          className={`input-date-sec ${
            fieldSetting?.isFormControl ? "input-with-btn" : ""
          }`}
        >
          <DatePicker
            label={labelName}
            id={name}
            keyId={keyId}
            selected={value}
            name={name}
            placeholder={fieldSetting?.placeholder}
            className="datepicker-field"
            onChange={handleDateChange}
            onBlur={handleOnBlur}
            isDisable={
              formSetting?.isViewOnly ||
              fieldSetting?.isDisable ||
              overRideProps?.isDisable
            }
            datePickerConfig={fieldSetting?.dateConfig}
            {...otherProps}
          />
          {fieldSetting?.isFormControl && (
            <FormControlTemplate
              fieldSetting={fieldSetting}
              handleButtonClick={handleButtonClick}
            />
          )}
        </div>
      </div>
      <ValidationText error={error || ""} />
    </span>
  );
};

FormDatePickerFields.propTypes = {
  dataField: PropTypes.string.isRequired,
  labelName: PropTypes.string,
  name: PropTypes.string.isRequired,
  keyId: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  error: PropTypes.string,
  formSetting: PropTypes.shape({
    isViewOnly: PropTypes.bool,
  }),
  overRideProps: PropTypes.shape({
    isDisable: PropTypes.bool,
  }),
  isRequired: PropTypes.bool,
  fieldSetting: PropTypes.shape({
    subTitle: PropTypes.string,
    placeholder: PropTypes.string,
    isDisable: PropTypes.bool,
    isFormControl: PropTypes.bool,
    dateConfig: PropTypes.object,
  }),
  onChange: PropTypes.func.isRequired,
  onBlure: PropTypes.func.isRequired,
  onActionChange: PropTypes.func,
};

export default FormDatePickerFields;
